export default "__VITE_ASSET__CgiAy5RD__"